var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-btn',{staticClass:"umbler-btn",attrs:{"color":"primary","icon":"icon-message-balloon"},on:{"click":_vm.openLink}})}
var staticRenderFns = []

export { render, staticRenderFns }